module.exports = __webpack_public_path__ + "2dffbcd4a0767b72047f3025d32ec587.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/key_art.png
// module id = 443
// module chunks = 0